export const setCandidate = ( data ) => ( {
    type: "PROFILE_SET_CANDIDATE",
    payload:data
} );

export const setCandidateField = ( data ) => ( {
    type: "PROFILE_SET_CANDIDATE_FIELD",
    payload:data
} );
